import React, { Component, Fragment } from "react";

class ShortEnrollmentDownload extends Component {
    componentDidMount() {
        if (document.getElementById("fill-out-form-directions")) {
            let directions = document.getElementById(
                "fill-out-form-directions"
            );
            directions.style.display = "none";
        }
    }

    render() {
        const { pdfUrl } = this.props;

        return (
            <Fragment>
                <div class="row spacer-medium mobile">&nbsp;</div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="white-font-68">thank you.</h2>
                        <p class="white-font-20 mt-2 mb-3">You have successfully signed up for Acadia Connect<sup>&reg;</sup>. Watch the video below to learn what to expect now that you're&nbsp;enrolled.</p>
                    </div>
                </div>
                <div class="row spacer-medium mobile">&nbsp;</div>
                <div class="row spacer-medium desktop">&nbsp;</div>
                <div class="row">
                    <div class="col-md-6">
                        <p className="submitted white-font">
                            Download a copy of your completed enrollment form to save
                            for your records.
                        </p>
                        <div className="grid">
                            <div className="row">
                                <div className="col-md-12">
                                    <a
                                        id="pc-enrollment-download-pdf-form"
                                        href={pdfUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button white button-spacing"
                                    >
                                        DOWNLOAD (
                                        <i
                                            className="fa fa-file-pdf-o"
                                            aria-hidden="true"
                                        ></i>{" "}
                                        PDF)
                                    </a>
                                </div>
                                <div className="col-md-12">
                                    <a class="white-font underline-link" href="/nuplazid/patient-caregivers">
                                        Return to homepage
                                    </a>
                                </div>
                                 <div className="row spacer-large mobile">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <p className="submitted white-font">
                            Sign up to receive additional information that could help you or the person you care for stay informed. Our emails cover a variety of topics, including talking with your healthcare provider, starting NUPLAZID, financial support, and more.
                        </p>
                        <div className="grid">
                            <div className="row">
                                <div className="col-md-12">
                                    <a
                                        href="/nuplazid/patient-caregivers/resources#mktoForm_3"
                                        className="button white button-spacing"
                                    >
                                        STAY INFORMED
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="row spacer-small">&nbsp;</div>
                <div className="row spacer-small">&nbsp;</div>
               
                
                {/*<div class="row">
                    <div class="col">
                        <h3>
                            Please visit{" "}
                            <a
                                className="teal"
                                href="https://nuplazid.com"
                                target="_blank"
                            >
                                NUPLAZID.com
                            </a>{" "}
                            for more information.
                        </h3>
                        <div class="row spacer-small desktop">&nbsp;</div>
                        <p>
                            Please read full{" "}
                            <a
                                href="https://nuplazid.com/pdf/nuplazid-prescribing-information.pdf"
                                target="_blank"
                            >
                                Prescribing Information
                            </a>
                            , including <b>Boxed WARNING</b>.
                        </p>
                    </div>
                </div>*/}
            </Fragment>
        );
    }
}

export default ShortEnrollmentDownload;
